import RecoveryAgent from "@/models/recoveryAgent.model";

export interface State {
  agents: RecoveryAgent[];
}

export const state: State = {
  agents: []
};
